export const DEFAULT_LOCALE = "en_CA";
export const DEFAULT_LOCALE_ISO = "en-CA";
export const DEFAULT_LANG = "en";

export interface Messages {
    readonly locale: string;

    has(key: string | null | undefined): boolean;
    prop(key: string | null | undefined, ...args: unknown[]): string;
}

// ISO format has hyphens (-) and Java format has underscores (_); ensure
// we are using the one we expect to receive in the map
export function toJavaLocaleFormat(localeString?: string | null): string | undefined {
    return localeString?.replace("-", "_") || undefined;
}
